function validateParams(params) {
  for (const param of params) {
    if (param instanceof Object) {
      for (const i in param) {
        // eslint-disable-next-line max-len
        if (i === undefined || i === null || !i.toString().length || param[i] === undefined || param[i] === null || !param[i].toString().length) {
          delete param[i]
        }
      }
    } else {
      throw new TypeError('Invalid instance')
    }
  }
}

export function queryParam(...params) {
  validateParams(params)
  params = Object.assign.apply(Object, [{}].concat(params))
  const esc = encodeURIComponent
  return (
    '?' +
    Object.keys(params)
      .map(k => {
        let value = params[k]
        value = typeof value === 'boolean' ? String(value).charAt(0).toUpperCase() + String(value).slice(1) : value
        return esc(k) + '=' + esc(value)
      })
      .join('&')
  )
}
